import { Layout, PageHeader, Rate } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import { useSelector } from "react-redux";
import { getImgUrl } from "../../../utils";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./sidebar";

const { Content } = Layout;

const MerchantLayout = ({
  children,
  merchantId,
  title,
  extra,
  subTitle,
}: {
  children: ReactElement;
  merchantId: string;
  title: string;
  subTitle?: string;
  extra?: ReactElement;
}): ReactElement => {
  const navigate = useNavigate();
  const { merchantInfo } = useSelector((state) => (state as any)?.authReducer);
  return (
    <React.Fragment>
      <Layout className="min-vh-100">
        <main>
          <div className="grid grid-cols-1 px-2 pt-4 xl:grid-cols-3 xl:gap-6 py-2">
            <div className="col-span-full">
              <PageHeader
                className="site-page-header px-0 py-0"
                onBack={() => navigate(-1)}
                title={
                  <h1 className="text-xl font-semibold text-gray-900 sm:text-2xl">
                    {title}
                  </h1>
                }
                extra={extra}
              />

              <nav className="flex mb-0" aria-label="Breadcrumb">
                <ol className="inline-flex items-center space-x-1 md:space-x-2">
                  <li className="inline-flex items-center">
                    <Link
                      to="/promotion/campaign"
                      className="inline-flex items-center text-gray-700 hover:text-gray-900"
                    >
                      Merchant
                    </Link>
                  </li>
                  <li>
                    <div className="flex items-center">
                      <svg
                        className="w-6 h-6 text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      <span
                        className="ml-1 text-sm font-medium text-gray-400 md:ml-2"
                        aria-current="page"
                      >
                        {subTitle}
                      </span>
                    </div>
                  </li>
                </ol>
              </nav>
            </div>

            <div className="col-span-full xl:col-auto">
              <div className="w-full bg-white border border-gray-200 rounded-2xl shadow-lg dark:bg-white mb-6">
              <div className="bg-transparent mb-4">
                  <div className="px-6 pt-6 pb-4 flex flex-col items-center text-center">
                    <div className="w-32 h-32 rounded-full bg-gray-100 overflow-hidden relative shadow-md border border-gray-200 flex items-center justify-center">
                      <img
                        src={getImgUrl(
                          merchantInfo?.merchantPersonalDetail?.profilePicture
                        )}
                        alt="merchant profile"
                        className="w-full h-full object-cover rounded-full"
                      />
                    </div>

                    <div className="mt-4 flex flex-col items-center">
                      <h2 className="text-lg text-black font-bold leading-6">
                        {merchantInfo?.merchantPersonalDetail?.fullName}
                      </h2>

                      <span className="mt-2 text-sm text-gray-500">
                        {merchantInfo?.mobileNumber?.replace("+88", "")}
                      </span>
                      <span className="mt-2 text-sm text-gray-500">
                        {merchantInfo?.merchantPersonalDetail?.email}
                      </span>

                      <div className="mt-3 flex justify-center">
                        <Rate
                          disabled
                          defaultValue={
                            merchantInfo?.merchantPersonalDetail?.rating || 3
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Sidebar merchantId={merchantId} />
            </div>

            <div className="col-span-2">
              <Layout>
                <Content className="main-content-layout">{children}</Content>
              </Layout>
            </div>
          </div>
        </main>
      </Layout>
    </React.Fragment>
  );
};

MerchantLayout.propType = {
  children: PropTypes.element,
};

export default MerchantLayout;